import { render } from "./three_secondary.vue?vue&type=template&id=0d8a2b38&scoped=true"
import script from "./three_secondary.vue?vue&type=script&lang=js"
export * from "./three_secondary.vue?vue&type=script&lang=js"

import "./three_secondary.vue?vue&type=style&index=0&id=0d8a2b38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8a2b38"]])

export default __exports__